import { Directive, HostListener, OnDestroy, OnInit } from '@angular/core';

import { IdleTrackingService } from './idle-tracking.service';

/**
 * Directive responsible for handling idle tracking.
 *
 * @author Jesse Bloomster e020902
 */
@Directive({
	selector: '[claimTrackerIdleTracking]',
	standalone: true
})
export class IdleTrackingDirective implements OnInit, OnDestroy {
	/**
	 * @param idleTrackingService the global idle tracking service
	 */
	constructor(private idleTrackingService: IdleTrackingService) {}

	/**
	 * Called when the directive is initialized.
	 */
	ngOnInit() {
		this.idleTrackingService.startService();
	}

	/**
	 * Called when the directive is destroyed.
	 */
	ngOnDestroy() {
		if (this.idleTrackingService.isServiceRunning()) {
			this.idleTrackingService.stopService();
		}
	}

	/**
	 * Reset idle tracking when specific document events occur.
	 */
	@HostListener('document:mousemove')
	@HostListener('document:keydown')
	@HostListener('document:mousedown')
	@HostListener('document:touchstart')
	@HostListener('document:touchmove')
	@HostListener('document:scroll')
	stopIdle() {
		// only reset the countdown if the service is running and the session expiring dialog is not open
		if (this.idleTrackingService.isServiceRunning() && !this.idleTrackingService.isSessionExpiringDialogOpen()) {
			this.idleTrackingService.resetIdleCountdown();
		}
	}
}
